module.exports = __webpack_public_path__ + "static/media/hello_img_3.73c57334.png";